import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-05df3c4e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "default-iframe-section" }
const _hoisted_2 = { class: "modal-iframe" }
const _hoisted_3 = { class: "modal-dialog-right" }
const _hoisted_4 = { class: "modal-content" }
const _hoisted_5 = {
  key: 0,
  class: "modal-body"
}
const _hoisted_6 = ["name", "src"]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          (_ctx.iframeUrl)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _createElementVNode("iframe", {
                  name: _ctx.iFrameName,
                  src: _ctx.iframeUrl,
                  width: "100%",
                  height: "100%",
                  frameborder: "0"
                }, null, 8, _hoisted_6)
              ]))
            : _createCommentVNode("", true)
        ])
      ])
    ])
  ]))
}